module.exports = __webpack_public_path__ + "createstatic/media/deleteBtn.681b52ca.svg";